import { render, staticRenderFns } from "./OnePager.vue?vue&type=template&id=1f55afc4&scoped=true"
import script from "./OnePager.vue?vue&type=script&lang=js"
export * from "./OnePager.vue?vue&type=script&lang=js"
import style0 from "./OnePager.vue?vue&type=style&index=0&id=1f55afc4&prod&lang=css"
import style1 from "./OnePager.vue?vue&type=style&index=1&id=1f55afc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55afc4",
  null
  
)

export default component.exports